module.exports = __webpack_public_path__ + "img/2down.f80be4f3.png";